import React from 'react';
import Environment from '../environment/environment.js'

import './color-schema.less';
import './color-schema/default.less';
import './color-schema/yellow.less';
import './color-schema/yellow-rich.less';
import './color-schema/orange.less';
import './color-schema/orange-rich.less';
import './color-schema/pink.less';
import './color-schema/pink-rich.less';
import './color-schema/red.less';
import './color-schema/red-rich.less';
import './color-schema/purple.less';
import './color-schema/purple-rich.less';
import './color-schema/cyan.less';
import './color-schema/cyan-rich.less';
import './color-schema/blue.less';
import './color-schema/blue-rich.less';
import './color-schema/green.less';
import './color-schema/green-rich.less';
import './color-schema/brown.less';
import './color-schema/brown-rich.less';
import './color-schema/grey.less';
import './color-schema/grey-rich.less';

export const ColorSchemaMixin = {

  //@@viewOn:statics
  statics: {
    UU5_Common_colorSchemaMixin: {
      classNames: {
        main: 'getMainClassUU5_Common_colorSchemaMixin'
      },
      defaults: {
        mainClassPrefix: 'color-schema-'
      }
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    // must be function because of dynamic adding color into colorSchema
    colorSchema: function (props, propName, componentName) {
      if (props[propName] && !Environment.colorSchemaMap[props[propName]]) {
        return new Error(
          'Invalid prop `' + propName + '` with value `' + props[propName] + '` supplied to' +
          ' `' + componentName + '`. Validation failed.'
        );
      }
    }
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps: function () {
    return {
      colorSchema: null
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  getInitialState: function () {
    this.registerMixin('UU5_Common_colorSchemaMixin');

    // in state, so every component can change color dynamically
    return {};
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  hasUU5_Common_colorSchemaMixin: function () {
    return this.hasMixin('UU5_Common_colorSchemaMixin');
  },

  getColorSchema: function () {
    let colorSchema = this.props.colorSchema || (this.getDefault() ? this.getDefault().colorSchema : null);
    return Environment.getColorSchema(colorSchema);
  },

  getUU5_Common_colorSchemaMixinProps: function () {
    return {
      colorSchema: this.props.colorSchema
    };
  },

  getUU5_Common_colorSchemaMixinPropsToPass: function () {
    return {};
  },

  getMainClassUU5_Common_colorSchemaMixin: function () {
    let colorSchema = this.getColorSchema();
    let result = '';
    if (colorSchema) {
      result = this.getDefault('mainClassPrefix', 'UU5_Common_colorSchemaMixin') + colorSchema;

      if (this.props.colorSchema !== colorSchema) {
        result += ' ' + this.getDefault('mainClassPrefix', 'UU5_Common_colorSchemaMixin') + this.props.colorSchema;
      }
    }

    return result;
  }
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  //@@viewOff:componentSpecificHelpers
};

export default ColorSchemaMixin;



// WEBPACK FOOTER //
// ./common/color-schema-mixin.js